import { useEffect, useState } from "react";
import { Popup } from "@/components/common/Popup";
import { Toggle } from "@/components/ui/toggle";
import { PlenumInfoSchema } from "./PlenumSchema";
import { PlenumInfo } from "./PlenumInfo";

import { useAppHub } from "@/realtime/AppHubProvider";
import { Button } from "../ui/button";


type Props = {
  isOpen: boolean;
  onClose: () => void;
  apiFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
  eventId: string ;
  onAdminSetVOD?: (plenumId: number, vod: boolean) => Promise<void> | void;
  onError?: (message: string) => void;
};

const dateTimeFormatter = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "short",
  timeStyle: "short",
});

function formatDateTime(value?: string | null) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return dateTimeFormatter.format(date);
}

export function PlenumSetupPopup({ isOpen, onClose, apiFetch, eventId,  onError }: Props) {
  const { connection, isConnected: isHubConnected } = useAppHub();
  const [plenums, setPlenums] = useState<PlenumInfoSchema[]>([]);
  const [loading, setLoading] = useState(false);
  const [editPlenumId, setPlenumId] = useState(null as number | null);

  const closeEdit = () => {
    if(editPlenumId)
    setPlenumId(null);
  else
    onClose();
  };




const toggleLive = async (plenumId: number | null) => {
    if(plenumId == null) return;

     if (!connection || !isHubConnected) 
      throw new Error("Hub is not connected");
    

    const current = plenums.find((item) => item.Id === plenumId);
    const nextLive = !(current?.Live ?? false);

    try {

      await connection.invoke("OnAdminActivatePlenum", plenumId, nextLive);

        setPlenums((prev) => prev.map((item) =>
          item.Id === plenumId ? { ...item, Live: nextLive } : item
        ));

      }
     catch (err) {
      console.error(err);
     
      onError?.("Failed to update Live state");
    }


  }

  const toggleQandA = async (plenumId: number | null) => {
    if(plenumId == null) return;

     if (!connection || !isHubConnected) 
      throw new Error("Hub is not connected");
    

    const current = plenums.find((item) => item.Id === plenumId);
    const nextQA = !(current?.QandALive ?? false);

    try {

      await connection.invoke("OnAdminSetQAStatus", plenumId, nextQA);

        setPlenums((prev) => prev.map((item) =>
          item.Id === plenumId ? { ...item, QandALive: nextQA } : item
        ));

      }
     catch (err) {
      console.error(err);
     
      onError?.("Failed to update Q&A state");
    }


  }

  const toggleVOD = async (plenumId: number | null) => {
    if(plenumId == null) return;
 if (!connection || !isHubConnected) 
      throw new Error("Hub is not connected");

    const current = plenums.find((item) => item.Id === plenumId);
    const nextVOD = !(current?.VOD ?? false);

    try {
            await connection.invoke("OnAdminSetVOD", plenumId, nextVOD);


        setPlenums((prev) => prev.map((item) =>
          item.Id === plenumId ? { ...item, VOD: nextVOD } : item
        ));

      }
    catch (err) {
      console.error(err);
     
      onError?.("Failed to update VOD state");
    }
  }
  useEffect(() => {
    if (!isOpen || !eventId) return;

    let active = true;

    const loadPlenums = async () => {
      try {
        setLoading(true);

        
        const res = await apiFetch(`/api/EventPool/GetPlenumListByEvent?isMarketPlace=false&eventId=${eventId}`);
        if (!res.ok) {
          if (active) setPlenums([]);
          return;
        }

        const data = await res.json();
        //join modes
          if(Array.isArray(data?.data)){
            data.data.forEach((plenum: PlenumInfoSchema) => {
              var joinModes = [];
              if(plenum.JoinPerPhone) joinModes.push("Phone");
              if(plenum.JoinPerWebAudio) joinModes.push("WebAudio");
              if(plenum.JoinPerCamera) joinModes.push("Camera");
             
             if(joinModes.length > 0)
                plenum.JoinMode = joinModes.join(", ");
              else
                plenum.JoinMode = "No Talkrequest";
            });
          }

        if (active) setPlenums(data.data );

      } catch (err) {
        console.error(err);
        if (active) {
          setPlenums([]);
          onError?.("Failed to load plenums");
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    loadPlenums();

    return () => {
      active = false;
    };
  }, [apiFetch, eventId, isOpen, onError]);

  return (
    <Popup isOpen={isOpen} onClose={closeEdit} title="Plenum" className="w-[95vw] max-w-6xl">
      {editPlenumId == null && (
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-100 text-left">
            <tr>
              <th className="px-3 py-2">Live</th>
              <th className="px-3 py-2">VOD</th>
              <th className="px-3 py-2">Q&amp;A</th>
              <th className="px-3 py-2">Id</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Date From</th>
              <th className="px-3 py-2">Date To</th>
              <th className="px-3 py-2">TR Modes</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="border-t">
                <td colSpan={8} className="px-3 py-4 text-center text-gray-500">
                  Loading plenums...
                </td>
              </tr>
            ) : plenums.length === 0 ? (
              <tr className="border-t">
                <td colSpan={8} className="px-3 py-4 text-center text-gray-500">
                  No plenums found
                </td>
              </tr>
            ) : (
              plenums.map((item, index) => (
                <tr key={`${item.Id ?? "plenum"}-${index}`} className="border-t align-middle" onClick={() => setPlenumId(item.Id ?? null)}  style={{ cursor: "pointer" }}>
                  <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}>
                    <Toggle checked={!!(item.Live ?? false)} onChange={()=>toggleLive(item.Id ?? null)} />
                  </td>
                  <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}>
                    <Toggle checked={!!(item.VOD ?? false)}  onChange={()=>toggleVOD(item.Id ?? null)}/>
                  </td>

                  <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}>
                    {item.HasQandA&&(
                    <Toggle checked={!!(item.QandALive ?? false)}  onChange={()=>toggleQandA(item.Id ?? null)}/>
                    )}
                  </td>
                  <td className="px-3 py-2">{item.Id ?? "-"}</td>
                  <td className="px-3 py-2">{item.Name ?? "-"}</td>
                  <td className="px-3 py-2">{formatDateTime(item.DateFrom ?? item.DateFrom_date)}</td>
                  <td className="px-3 py-2">{formatDateTime(item.DateTo ?? item.DateTo_date)}</td>
                  <td className="px-3 py-2">{item.JoinModes ?? item.JoinMode ?? "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <Button className="mt-4" onClick={() => setPlenumId(-1)}>New Plenum</Button>
      </div>)}

      {editPlenumId != null && (
        <div>
          <PlenumInfo  eventId={eventId} plenumId={editPlenumId} onClose={() => setPlenumId(null)} onDeleted={()=>{setPlenums([...plenums.filter(p => p.Id !== editPlenumId)]); setPlenumId(null);}}/>
        </div>
      )}
    </Popup>
  );
}
